import { api } from "..";

export const protectedActionTest = async () => {
  const res = await api.client.post("/tests/protected-action");
  return res.data;
};
